<app-header></app-header>
<!--Breadcrumb-->
		<section>
			<div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
				<div class="header-text mb-0">
					<div class="container">
						<div class="text-center ">
							<h1 class="mb-0">My Cars</h1>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--Breadcrumb-->

		<!--Section-->
		<section class="sptb">
			<div class="container">
				<div class="row">
					<div class="col-xl-3 col-lg-12 col-md-12">
                        <!-- my account left menu -->
                <app-my-account-left-menu></app-my-account-left-menu>
                <!-- /my account left menu -->
                    
                        
                    </div>
					<div class="col-xl-9 col-lg-12 col-md-12 table_my_car">
					    <div class="tab-menu-heading">
												<div class="tabs-menu col-xl-9 col-lg-9 col-md-9">
													<!-- Tabs -->
													<ul class="nav panel-tabs">
														<li class="uploaded-tab" style="padding:2%"><a href="#uploaded-by" class="active" data-toggle="tab" (click)="getMyCarList()">Uploaded to Sell</a></li>
														<li class="shortlisted-tab" style="padding:2%"><a href="#Shortlisted_by" data-toggle="tab" (click)="getFavoriteCarsList(1)">Shortlisted to Buy</a></li>
														<li class="bid-cars-tab" style="padding:2%"><a href="#bid_cars_by" data-toggle="tab">Okshan pending</a></li>
														<li class="make-offer-tab" style="padding:2%"><a href="#pending_make_offer" data-toggle="tab" (click)="getMakeOfferList()">Made on Offer</a></li>
														<li class="buy-now-tab" style="padding:2%"><a href="#pending_buy_now" data-toggle="tab" (click)="getBuyNowList()">Opted for Buy Now</a></li>
												    </ul>
													
												</div>
												<div class="tabs-menu col-xl-3 col-lg-3 col-md-3">
												<select #carType class="form-control" (change)="onChangeType()">
                                            <option value="0">All Cars</option>
											<option value="2">Okshan Cars</option>
											<option value="1">Fixed Price cars</option>
                                            </select>
											</div>
												
													<div class="tabs-menu-heading col-xl-4 col-lg-4 col-md-4">
													<!-- Tabs -->
													<ul class="nav-heading ">
														<!-- <li class="heading-menu uploaded-li">Cars Uploaded by Me</li>
														<li  class="heading-menu shortlisted-li" style="display:none">Cars Shortlisted by Me</li>
														<li  class="heading-menu bid-cars-li"  style="display:none">Cars Bid by Me</li> -->
													</ul>
												</div>
											</div>
					    <div id="uploaded-by"  class="tab-pane active">
						<div class="card mb-3">
							
							<div class="padding_125">
								<div class="table-responsive border-top">
									<table class="table table-bordered table-hover text-nowrap">
										<thead>
											<tr>
												<th>Reg No</th>
												<th>Unique Id</th>
												<th> Detail</th>												
												<th> Okshan Value</th>										
												<th> Settlement Amount</th>
                                                <th> Upload Date/Time</th>
												<th>Status</th>
                                                <th>Action</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of myCarList">
												<td class="text-primary">{{item.registration_no}}</td>
												<td>{{item.unique_id}}</td>
												<td>{{getModelFromId(item.car_model_id)}} {{getVariantFromId(item.car_variants)}}</td>												
												<td class="font-weight-semibold fs-16">₹{{item.fare_market_value}}</td>
												<td class="font-weight-semibold fs-16" *ngIf="item.st!='Car Sold'"></td>
												<td class="font-weight-semibold fs-16" *ngIf="item.st=='Car Sold'">₹{{item.settlement_amount}}</td>
                                                <td>{{item.created_date_time}}</td>
												<td>
													{{item.st}}
												</td>
                                                <td>
                                                    <!-- <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="carDetail(item.id)"> -->
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="carDetail2(item.id,item.sale_by)" title="Show Detail">    
														<i class="fa fa-eye"></i>
                                                    </a>
													<a *ngIf="item.sale_by==2" class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" title="Live Okshan Link" (click)="grenerateLiveOkshanLink(item.id)" onclick="$('#live_okshan_link_model').modal('show')">    
														<i class="fa fa-external-link"></i>
                                                    </a>
													<a  *ngIf="(item.st=='FPS Scheduled' || item.st=='Car Sold') && item.final_bit==1 && item.date_status==1" class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="showOffer(item.id)" title="Show Detail">    
														Show Offers
                                                    </a>


                                                    <a  *ngIf="item.st=='FPS Scheduled' && item.final_bit==1 && item.sale_by==1" class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="getViewAcceptOfferCarsList(item.id, item.sale_by)" title="View Accept Offer">    
														<i class="fa fa-hand-o-right"></i>
                                                    </a>

													<!-- <a  *ngIf="item.st=='FPS Scheduled' && item.final_bit==1 && item.sale_by==1" class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="getAcceptOfferCarsList(item.id)" title="Accept Offer">    
														<i class="fa fa-hand-o-right"></i>
                                                    </a> -->

                                                    <!--a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a-->
                                                </td>
											</tr>											
										</tbody>
									</table>
								</div>
								
							</div>
						</div>
						</div>
						
						
					    <div id="pending_make_offer"  class="tab-pane  ">
						<div class="card mb-3">
							
							<div class="padding_125">
								<div class="table-responsive border-top">
									<table class="table table-bordered table-hover text-nowrap">
										<thead>
											<tr>
												<th>Title</th>
												<th> Unique Id</th>												
												<th> Offered Amount</th>
                                                <th> Date</th>
												<th>Status</th>
												<th>Remarks</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of makeOfferList">
												<td class="text-primary">{{item.title}}</td>
												<td>{{item.unique_id}}</td>												
												<td class="font-weight-semibold fs-16">₹{{item.security_amount}}</td>
                                                <td>{{item.created_at}}</td>
												<td *ngIf="item.status==1">Sold</td>
												<td *ngIf="item.status==0">Pending</td>
												<td *ngIf="item.status==2">Rejected</td>
												<td *ngIf="item.status==4">Cancelled</td>
												<td>{{item.cancelled_remark}}</td>
											</tr>											
										</tbody>
									</table>
								</div>
								
							</div>
						</div>
						</div>
						
					    <div id="pending_buy_now"  class="tab-pane  ">
						<div class="card mb-3">
							
							<div class="padding_125">
								<div class="table-responsive border-top">
									<table class="table table-bordered table-hover text-nowrap">
										<thead>
											<tr>
												<th>Title</th>
												<th> Unique Id</th>												
												<th> Security Amount</th>
                                                <th> Date</th>
												<th>Status</th>
												<th>Remarks</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of buyNowList">
												<td class="text-primary">{{item.title}}</td>
												<td>{{item.unique_id}}</td>												
												<td class="font-weight-semibold fs-16">₹{{item.security_amount}}</td>
                                                <td>{{item.created_at}}</td>
												<td *ngIf="item.status==1">Sold</td>
												<td *ngIf="item.status==0">Pending</td>
												<td *ngIf="item.status==2">Rejected</td>
												<td *ngIf="item.status==4">Cancelled</td>
												<td>{{item.cancelled_remark}}</td>
											</tr>											
										</tbody>
									</table>
								</div>
								
							</div>
						</div>
						</div>
						
						 <div id="Shortlisted_by" class="tab-pane tab-content" >
						<div id="tab-11" class="card mb-3">
						<div class="padding_125">
						    <div  *ngFor="let item of favCarList">
							<div class="card overflow-hidden" *ngIf="item.sale_by==2">
                                                        <div class="ribbon ribbon-top-left text-danger"><span class="bg-danger">Upcoming</span></div>
                                                <div class="d-md-flex">
                                                    <div class="item-card9-img">
                                                       <!--<div class="arrow-ribbon bg-primary">Live</div> -->
                                                        <div class="item-card9-imgs">
                                                            <a class="link" ></a>
                                                                       <div id="carousel-controls{{item.id}}" class="carousel slide" data-ride="carousel" data-interval="false">
											<div class="carousel-inner">
												<div class="carousel-item active" *ngIf="item.pic_1!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_1}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_2!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_2}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_3!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_3}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_4!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_4}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_5!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_5}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_6!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_6}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_7!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_7}}" data-holder-rendered="true">
												</div>
											</div>
											<a class="carousel-control-prev1" href="#carousel-controls{{item.id}}" role="button" data-slide="prev">
												<i class="fa fa-angle-left"></i>
												
											</a>
											<a class="carousel-control-next1" href="#carousel-controls{{item.id}}" role="button" data-slide="next">
											<i class="fa fa-angle-right"></i>
												
											</a>
										</div>
                                                        </div>
                                                       <div class="item-overly-transs">
															  <span> 
                                                                    <a  class="" title="Kilometrs"><i class="fa fa-tachometer  mr-1"></i> {{item.kilometer}}Kms</a>
                                                                    <a  class="" title="FuealType"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="gas-pump" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-gas-pump fa-w-16" style=""><path fill="currentColor" d="M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z" class=""></path></svg>{{item.car_fuel_type_name}}</a></span></div>
                                                       
                                                    </div>
                                                    <div class="card border-0 mb-0">
											
                                                        <div class="card-body ">
                                                            <div class="item-card9 index-detail">
														
                                                                <a (click)="carDetail(item.id)"  class="text-dark cursor_pointer"><h4 class="font-weight-semibold mt-1">{{item.title}}</h4></a>
                                                                
																 	
																 <div class="item-card9-icons">
                                                            <a  class="item-card9-icons1 wishlist like-counter cursor_pointer"  data-toggle="tooltip" data-placement="top" title="Shortlist"><i class="fa fa fa-heart"></i></a>
                                                            <!-- <a href="" class="like-counter item-card9-icons1 like fs-14 bg-blue"><i class="fa fa-thumbs-o-up mr-1"></i><span class="counter fs-14 mt-0">12</span></a> -->
                                                        </div>
                                                                <div class="item-card9-desc mb-2 d-xs-flex ">
                                                                    <!-- <a  class="mr-4"><span class=""><i class="fa fa-map-marker text-muted mr-1"></i> </span></a> -->
                                                                    <!-- <a  class="mr-4"><span class=""><i class="fa fa-calendar-o text-muted mr-1"></i>  {{item.created_date_time | dateAgo}}</span></a> -->
                                                                </div>
                                                                <!-- <p class="mb-0 leading-tight">Lorem Ipsum available, but the majority have suffered alteration in some form</p> --> 
																<div class="col-md-12 col-lg-12 col-xl-12 icn-desgin">
																<p class="mb-0 "> <span class="auctionspan">  <span class=" font-weight-bold"> Okshan Value  <i class="pe-7s-info " data-toggle="tooltip" title="" data-original-title="Okshan Value is the true market estimate of a car that maximum chances of procuring a car while maintaining healthy profit margin."></i>:  </span><i class="fa fa-inr" aria-hidden="true"></i> {{item.fare_market_value | number}}
																</span><span class="auctionspan"><span class=" font-weight-bold pl-0">&nbsp;&nbsp;Highest Bid:  </span><i class="fa fa-inr" aria-hidden="true"></i></span><span class="auctionspan"> <span class=" font-weight-bold1"> Transport charges (Additional) <i class="pe-7s-info" data-toggle="tooltip" title="" data-original-title="pe-7s-info"></i>: </span><i class="fa fa-inr" aria-hidden="true"></i> </span></p>
                                                            </div>
														    	<div class="col-md-12 col-lg-12 col-xl-12 item-overly-transa mt-2">
														           	<span class="start-time"><span class="start-in">Starts In</span><a class=" hour"></a></span>
																
																</div>
                                                            </div>
                                                        </div>
                                                            <div class="card-footer pt-4 pb-4 pr-4 pl-4 d-sm-flex">
                                                            <div class="item-card9-footer col-md-8 col-lg-8 col-xl-8">
                                                                
                                                                <div class=" main-wrap-set">
                                                                    <a  class="mr-2 border-1" title="Car type"><span> Reg. No:</span> <br>
                                                                    <span class="heading-font" *ngIf="sessionId==item.profile_detail_id"> {{item.registration_no}}</span>
                                                                    <span class="heading-font" *ngIf="sessionId!=item.profile_detail_id"> {{item.registration_no.substring(0,5)}}XXXX</span>
                                                                    </a>
                                                                    <a  class="mr-2 border-4" title="Kilometrs"> <span >Insurance Type:</span><br><span class="heading-font"> </span></a>
                                                                    <a  class=" border-3" title="FuealType"><span >Centre City: </span><br><span class="heading-font"> </span></a>
                                                                </div> 
                                                            </div>
                                                            <div class="col-md-4  col-lg-4 col-xl-4">
                                                        	<span class="bid-btn">
                                                            <a class="btn btn-square btn-danger text-white" (click)=carDetail(item.id)>Bid Now</a>
                                                            
                                                            </span>
                                                        	</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
											<div class="card overflow-hidden" *ngIf="item.sale_by==1">
                                                        <!--<div class="ribbon ribbon-top-left text-danger"><span class="bg-danger">Upcoming</span></div>-->
                                                <div class="d-md-flex">
                                                    <div class="item-card9-img">
                                                       <!--<div class="arrow-ribbon bg-primary">Live</div> -->
                                                        <div class="item-card9-imgs">
                                                            <a class="link" ></a>
                                                                       <div id="carousel-controls{{item.id}}" class="carousel slide" data-ride="carousel" data-interval="false">
											<div class="carousel-inner">
												<div class="carousel-item active" *ngIf="item.pic_1!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_1}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_2!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_2}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_3!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_3}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_4!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_4}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_5!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_5}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_6!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_6}}" data-holder-rendered="true">
												</div>
												<div class="carousel-item" *ngIf="item.pic_7!=''">
													<img class="d-block w-max-100" alt="" src="{{fileUrl+item.pic_7}}" data-holder-rendered="true">
												</div>												
											</div>
											<a class="carousel-control-prev1" href="#carousel-controls{{item.id}}" role="button" data-slide="prev">
												<i class="fa fa-angle-left"></i>
												
											</a>
											<a class="carousel-control-next1" href="#carousel-controls{{item.id}}" role="button" data-slide="next">
											<i class="fa fa-angle-right"></i>
												
											</a>
										</div>
                                                        </div>
                                                       <div class="item-overly-transs">
															  <span> 
                                                                    <a  class="" title="Kilometrs"><i class="fa fa-tachometer  mr-1"></i> {{item.kilometer}}Kms</a>
                                                                    <a  class="" title="FuealType"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="gas-pump" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-gas-pump fa-w-16" style="
    
"><path fill="currentColor" d="M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z" class=""></path></svg> {{item.car_fuel_type_name}}</a></span></div>
                                                       
                                                    </div>
                                                    <div class="card border-0 mb-0">
											
                                                        <div class="card-body ">
                                                            <div class="item-card9">
														
                                                                <a (click)=carDetail(item.id) class="text-dark cursor_pointer"><h4 class="font-weight-semibold mt-1">{{item.title}}</h4></a>
                                                                
																
                                                                <div class="item-card9-desc mb-2 d-flex">
                                                                    <a  class="mr-4"><span class=""><i class="fa fa-map-marker text-muted mr-1"></i> </span></a>
                                                                    <a  class="mr-4"><span class=""><i class="fa fa-calendar-o text-muted mr-1"></i>  {{item.created_date_time}}</span></a>
                                                                    <a  class="item-card9-icons1 wishlist like-counter heart-icon-main cursor_pointer" data-toggle="tooltip" data-placement="top" title="Shortlist"> <i class="fa fa fa-heart"></i></a>
                                                            
                                                                </div>
                                                                <!-- <p class="mb-0 leading-tight">Lorem Ipsum available, but the majority have suffered alteration in some form</p> -->
																<div class="col-md-12 col-lg-12 col-xl-12 pl-0">
																 <p class="mb-0"> <span class=" span-price font-weight-bold pl-0">Price:  </span><i class="fa fa-inr" aria-hidden="true"></i> {{item.fare_market_value | number}}</p>
                                                            </div>
														    	
                                                            </div>
                                                        </div>
                                                            <div class="card-footer pt-4 pb-4 pr-4 pl-4 d-lg-flex">
                                                            <div class="item-card9-footer col-md-12 col-lg-7 col-xl-7">
                                                                
                                                                <div class=" main-wrap-set">
                                                                    <a  class="mr-2 border-1" title="Car type"><span> Reg. No:</span> <br>
                                                                    <span class="heading-font" *ngIf="sessionId==item.profile_detail_id"> {{item.registration_no}}</span>
                                                                    <span class="heading-font" *ngIf="sessionId!=item.profile_detail_id"> {{item.registration_no.substring(0,5)}}XXXX</span>
                                                                    </a>
                                                                    <a  class="mr-2 border-4" title="Kilometrs"> <span >Insurance Type:</span><br><span class="heading-font">  </span></a>
                                                                    <a  class=" border-3" title="FuealType"><span >Centre City: </span><br><span class="heading-font"> </span></a>
                                                                </div> 
                                                            </div>
                                                            <div class="col-md-12  col-lg-5 col-xl-5 d-lg-flex">
                                                        	<span class="bid-btn">
                                                            <a class="btn btn-square btn-danger text-white"  (click)=carDetail(item.id)>Buy Now</a>
                                                            </span>
                                                             <span class="bid-btn">
                                                             <a class="btn btn-square btn-success text-white"  (click)=carDetail(item.id)>Make An Offer</a>
                                                             </span>
                                                        	</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>	
											</div>					
							</div>
						</div>
						</div>
						
						 <div id="bid_cars_by"  class="tab-pane ">
						<div class="card mb-3">
							
							<div class="padding_125">
								<div class="table-responsive border-top">
									<table class="table table-bordered table-hover text-nowrap">
										<!-- <thead>
											<tr>
												<th>Reg No </th>
												<th>Car Detail</th>												
												<th>Bid Amount</th>
                                                <th>Bid Date Time</th>
												<th>Status</th>
                                                <th>Action</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="text-primary">PB 10 2323</td>
												<td>Kia Seltos</td>												
												<td class="font-weight-semibold fs-16">₹893</td>
                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-danger">In Negotiation</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">PB 8 5623</td>
												<td>Maruti Vitara Brezza</td>
												<td class="font-weight-semibold fs-16">₹254</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-primary">Not Completed</a>
												</td>
                                                                                                <td>
                                                                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                                                                        <i class="fa fa-eye"></i>
                                                                                                    </a>
                                                                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                                                                        <i class="fa fa-info"></i>
                                                                                                    </a>
                                                                                                </td>
											</tr>
											<tr>
												<td class="text-primary">CH 1 1232</td>
												<td>Maruti Swift</td>
												<td class="font-weight-semibold fs-16">₹352</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-success">Completed</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">PB 5 2773</td>
												<td>Mahindra Scorpio</td>
												<td class="font-weight-semibold fs-16">₹643</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-danger">Pending</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">HP 10 8877</td>
												<td>Hyundai Elite i20</td>
												<td class="font-weight-semibold fs-16">₹392</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-success">Completed</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">CH 10 0099</td>
												<td>Tata Altroz</td>
												<td class="font-weight-semibold fs-16">₹295</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-danger">Awaiting Transport</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">PB 15 8636</td>
												<td>Hyundai Venue</td>
												<td class="font-weight-semibold fs-16">₹836</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-primary">RC Pending</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">PB 26 9090</td>
												<td>Maruti Baleno</td>
												<td class="font-weight-semibold fs-16">₹254</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-success">Completed</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
											<tr>
												<td class="text-primary">PB 26 0190</td>
												<td>Toyota Fortuner</td>
												<td class="font-weight-semibold fs-16">₹654</td>
                                                                                                <td>07-12-2019 10:20 AM</td>
												<td>
													<a  class="badge badge-primary">Pending</a>
												</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" >
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View Inspection" >
                                                        <i class="fa fa-info"></i>
                                                    </a>
                                                </td>
											</tr>
										</tbody> -->
									</table>
								</div>
								
							</div>
						</div>
						</div>
						
						
						<!-- <div class="center-block text-center">
                            <ul class="pagination mb-5 mb-lg-0">
                                <li class="page-item page-prev disabled">
                                    <a class="page-link"  tabindex="-1">Prev</a>
                                </li>
                                <li class="page-item active"><a class="page-link" >1</a></li>
                                <li class="page-item"><a class="page-link" >2</a></li>
                                <li class="page-item"><a class="page-link" >3</a></li>
                                <li class="page-item page-next">
                                    <a class="page-link" >Next</a>
                                </li>
                            </ul>
                        </div> -->
					</div>
				</div>
			</div>
		</section>
		<!--/Section-->
		<!---live okshan link model -->
		<div class="modal fade" id="live_okshan_link_model" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Live Okshan Link</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>                        
                    </div>
                    <div class="modal-body">
                        <div>
						<input id="live_okshan_link" type="text" value="{{liveOkshanUrl}}" style="width:80%"/>
						<a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" title="Live Okshan Link" style="margin-left:2%">    
														<i class="fa fa-copy" onclick="copyFromId('live_okshan_link')"></i>
                                                    </a>
						</div>
                    </div>                    
                </div>
            </div>
        </div>
		<!---/live okshan link model -->
<app-footer></app-footer>
